import { httpGatewayService } from "@/modules/common/services";
import axios from "axios";
import moment from "moment";
//
// const HTTP = axios.create({
//   baseURL: process.env.VUE_APP_NOTIFICATION_CENTER_URL,
//   withCredentials: false
// });
const DEFAULT_POLLING_TIMEOUT = 30000
const baseRoute = 'business/notificationscenter'
const notificationsRoute = 'v1/notifications'
const notificationsCounterRoute = 'v1/notificationscounters'
const typesRoute = 'v1/notificationstype'
const notificationsMetadataRoute = 'v1/notificationsmetadata'
let cancelTokenSource

const getIsNewNotificationCounter = async (currentCounter) => {
  cancelTokenSource = axios.CancelToken.source();
  const getParams = {
    'filter[is_new][eq]': 1
  }
  return await httpGatewayService.get(`${baseRoute}/${notificationsCounterRoute}/${currentCounter}`,
    { ...getParams },
    {
      cancelToken: cancelTokenSource.token,
      timeout: DEFAULT_POLLING_TIMEOUT
    })
    .then(res => res.data?.counters?.new_notifications_count)
}

const getNotifications = async (numberOfDays) => {
  const minDate = moment().subtract(numberOfDays, 'days').format('YYYY-MM-DD');
  const getParams = {'filter[created_at][gte]' : minDate, 'sort' : 'created_at:desc'}
  return await httpGatewayService.get(`${baseRoute}/${notificationsRoute}`,
    { ...getParams })
    .then(res => {
      return res.data?.notifications
    })
}

const getNotificationsTypes = async () => {
  return await httpGatewayService.get(`${baseRoute}/${typesRoute}`)
    .then(res => {
      return res.data?.notifications_types
    })
}

const getNotificationsMetadata = async () => {
  return await httpGatewayService.get(`${baseRoute}/${notificationsMetadataRoute}`)
    .then(res => {
      return res.data?.notifications_metadata
    })
}

const resetNotificationCounter = async () => {
  return await httpGatewayService.put(`${baseRoute}/${notificationsRoute}/?filter[is_new][eq]=1`,
    {
      is_new:false
    })
    .then(res => res.data)
}
const setNotificationReadStatus = async (notification_uid, status) => {
  return await httpGatewayService.put(`${baseRoute}/${notificationsRoute}/${notification_uid}`,
    {
      read:status
    })
    .then(res => res.data)
}

const setAllNotificationsAsRead = async () =>{
  return await httpGatewayService.put(`${baseRoute}/${notificationsRoute}?filter[read][eq]=0`,
    {
      read:true
    })
    .then(res => res.data)
}

const cancelRequest = () => {
  if (cancelTokenSource) {
    cancelTokenSource.cancel('cancel');
  }
}

const getAvatarByType = (type) =>{
  switch (type){
    case 'clients':
      return require('@/assets/images/clients_thumbnail.svg');
    case 'marketing':
      return require('@/assets/images/marketing_thumbnail.svg');
    case 'calendar':
      return require('@/assets/images/calendar_thumbnail.svg');
    case 'payments':
      return require('@/assets/images/payment_thumbnail.svg');
    case 'booking':
      return require('@/assets/images/booking_thumbnail.svg');
    case 'teamchat':
      return require('@/assets/images/team_chat_thumbnail.svg');
    default:
      return ''
  }
}

export const notificationCenterService = {
  getIsNewNotificationCounter,
  getNotifications,
  getNotificationsTypes,
  getNotificationsMetadata,
  resetNotificationCounter,
  cancelRequest,
  setNotificationReadStatus,
  setAllNotificationsAsRead,
  getAvatarByType
}
